export interface SwedishCounty {
  en: string;
  sv: string;
  municipalities: string[];
  aliases: string[];
}

export const swedishCounties: Record<string, SwedishCounty> = {
  Skåne: {
    en: 'Skåne County',
    sv: 'Skåne',
    municipalities: [
      'Malmö',
      'Helsingborg',
      'Lund',
      'Kristianstad',
      'Landskrona',
      'Trelleborg',
      'Ängelholm',
      'Hässleholm',
      'Ystad',
      'Eslöv',
      'Höganäs',
      'Båstad',
      'Simrishamn'
    ],
    aliases: ['Skåne', 'Scania', 'Southern Sweden', 'Södra Sverige']
  },
  'Västra Götaland': {
    en: 'Västra Götaland County',
    sv: 'Västra Götaland',
    municipalities: [
      'Göteborg',
      'Gothenburg',
      'Borås',
      'Uddevalla',
      'Trollhättan',
      'Skövde',
      'Lidköping',
      'Vänersborg',
      'Alingsås',
      'Strömstad',
      'Lysekil',
      'Ulricehamn',
      'Mariestad',
      'Falköping'
    ],
    aliases: ['Västra Götaland', 'VGR', 'Western Sweden', 'Västra Sverige']
  },
  Stockholm: {
    en: 'Stockholm County',
    sv: 'Stockholm',
    municipalities: [
      'Stockholm',
      'Huddinge',
      'Solna',
      'Sundbyberg',
      'Nacka',
      'Södertälje',
      'Täby',
      'Sollentuna',
      'Lidingö',
      'Järfälla',
      'Sigtuna',
      'Norrtälje'
    ],
    aliases: ['Stockholm', 'Stockholmsregionen', 'Greater Stockholm', 'Stor-Stockholm']
  },
  Uppsala: {
    en: 'Uppsala County',
    sv: 'Uppsala',
    municipalities: ['Uppsala', 'Enköping'],
    aliases: ['Uppsala', 'Uppland']
  },
  Östergötland: {
    en: 'Östergötland County',
    sv: 'Östergötland',
    municipalities: ['Linköping', 'Norrköping', 'Motala'],
    aliases: ['Östergötland', 'East Gothland']
  },
  Halland: {
    en: 'Halland County',
    sv: 'Halland',
    municipalities: ['Halmstad', 'Varberg', 'Falkenberg', 'Kungsbacka'],
    aliases: ['Halland']
  },
  Blekinge: {
    en: 'Blekinge County',
    sv: 'Blekinge',
    municipalities: ['Karlskrona', 'Ronneby', 'Karlshamn'],
    aliases: ['Blekinge']
  },
  Kronoberg: {
    en: 'Kronoberg County',
    sv: 'Kronoberg',
    municipalities: ['Växjö', 'Ljungby', 'Älmhult'],
    aliases: ['Kronoberg', 'Småland']
  },
  Kalmar: {
    en: 'Kalmar County',
    sv: 'Kalmar',
    municipalities: ['Kalmar', 'Oskarshamn', 'Västervik', 'Vimmerby'],
    aliases: ['Kalmar', 'Öland']
  },
  Gotland: {
    en: 'Gotland County',
    sv: 'Gotland',
    municipalities: ['Visby'],
    aliases: ['Gotland']
  },
  Jönköping: {
    en: 'Jönköping County',
    sv: 'Jönköping',
    municipalities: ['Jönköping', 'Värnamo', 'Nässjö', 'Tranås', 'Vetlanda', 'Eksjö'],
    aliases: ['Jönköping', 'Småland']
  },
  Södermanland: {
    en: 'Södermanland County',
    sv: 'Södermanland',
    municipalities: ['Eskilstuna', 'Nyköping', 'Katrineholm'],
    aliases: ['Södermanland', 'Sörmland']
  },
  Örebro: {
    en: 'Örebro County',
    sv: 'Örebro',
    municipalities: ['Örebro', 'Lindesberg', 'Karlskoga'],
    aliases: ['Örebro', 'Närke']
  },
  Västmanland: {
    en: 'Västmanland County',
    sv: 'Västmanland',
    municipalities: ['Västerås', 'Köping'],
    aliases: ['Västmanland']
  },
  Dalarna: {
    en: 'Dalarna County',
    sv: 'Dalarna',
    municipalities: [
      'Falun',
      'Borlänge',
      'Ludvika',
      'Avesta',
      'Mora',
      'Leksand',
      'Rättvik',
      'Orsa',
      'Älvdalen',
      'Smedjebacken',
      'Säter',
      'Hedemora',
      'Gagnef',
      'Vansbro',
      'Malung-Sälen'
    ],
    aliases: ['Dalarna', 'Dalecarlia']
  },
  Gävleborg: {
    en: 'Gävleborg County',
    sv: 'Gävleborg',
    municipalities: [
      'Gävle',
      'Sandviken',
      'Hudiksvall',
      'Bollnäs',
      'Söderhamn',
      'Ljusdal',
      'Hofors',
      'Ovanåker',
      'Nordanstig',
      'Ockelbo'
    ],
    aliases: ['Gävleborg', 'Gästrikland', 'Hälsingland']
  },
  Västernorrland: {
    en: 'Västernorrland County',
    sv: 'Västernorrland',
    municipalities: ['Sundsvall', 'Örnsköldsvik', 'Härnösand', 'Sollefteå'],
    aliases: ['Västernorrland', 'Ångermanland', 'Medelpad']
  },
  Jämtland: {
    en: 'Jämtland County',
    sv: 'Jämtland',
    municipalities: ['Östersund', 'Åre'],
    aliases: ['Jämtland', 'Härjedalen']
  },
  Västerbotten: {
    en: 'Västerbotten County',
    sv: 'Västerbotten',
    municipalities: ['Umeå', 'Skellefteå', 'Lycksele'],
    aliases: ['Västerbotten', 'Lappland']
  },
  Norrbotten: {
    en: 'Norrbotten County',
    sv: 'Norrbotten',
    municipalities: ['Luleå', 'Piteå', 'Kiruna', 'Boden', 'Gällivare'],
    aliases: ['Norrbotten', 'Lappland', 'Northern Sweden', 'Norra Sverige']
  }
};

export function getAllCounties(): string[] {
  return Object.keys(swedishCounties);
}

export function getLocationsForCounty(countyName: string): string[] {
  const county = swedishCounties[countyName];
  if (!county) return [];
  return [countyName, ...county.municipalities];
}

export function getCountyDisplayName(countyName: string, language: 'en' | 'sv' = 'sv'): string {
  const county = swedishCounties[countyName];
  if (!county) return countyName;
  if (language === 'en') return county.en;
  return county.sv.replace(/ län$/, '');
}

/**
 * Does the assignment location string match any of the selected regions
 * (either direct location names, county names, aliases, or municipalities)?
 */
export function locationMatchesRegions(
  assignmentLocation: string | null | undefined,
  selectedRegions: string[]
): boolean {
  if (!assignmentLocation) return false;
  if (selectedRegions.length === 0) return true;

  const normalized = assignmentLocation.toLowerCase();
  return selectedRegions.some((region) => {
    const r = region.toLowerCase();
    if (normalized.includes(r)) return true;
    const county = swedishCounties[region];
    if (county) {
      if (county.aliases.some((a) => normalized.includes(a.toLowerCase()))) return true;
      if (county.municipalities.some((m) => normalized.includes(m.toLowerCase()))) return true;
    }
    return false;
  });
}
